import React, { FC } from 'react';
import { useIntersectionObserver } from '../../../../utils/hooks/useIntersectionObserver';
import { LightUploadingFile, UploadingFile } from '../UploadingFile';
import { IOuter } from './UploadingItem.types';

export const UploadingItem: FC<IOuter> = ({ item, shouldStayVisible, onOpenDestinationFolder, currentFolder }) => {
  const [itemRef, itemEntry] = useIntersectionObserver();

  return (
    <div ref={itemRef}>
      {shouldStayVisible || itemEntry?.isIntersecting ? (
        <UploadingFile
          uploadingFile={item}
          onOpenDestinationFolder={onOpenDestinationFolder}
          currentFolder={currentFolder}
        />
      ) : (
        <LightUploadingFile />
      )}
    </div>
  );
};
